import $ from 'jquery';
import Ps from 'perfect-scrollbar';
import debounce from './utils/debounce';

class SubMenu {
    constructor (mobileBreakpoint) {
        this.mobileBreakpoint = mobileBreakpoint;
        this.$window = $(window);
        this.$wrapper = $('.js-sub-menu');
        this.$links = $('.js-sub-menu-links');
        this.$button = $('.js-sub-menu-button');

        // Events
        //----------------------------------------
        this.$button.on('click', $.proxy(this.toggleMenu, this)).attr('aria-expanded', 'false');

        // Scrollbars
        //----------------------------------------
        // this.scrollbars = [];

        if (this.$links) {
            this.$window.on('resize', debounce(() => {
                if (this.$window.width() <= this.mobileBreakpoint) {
                    // this.destroyScrollbars();
                } else {
                    this.resetEverything();
                    // this.addScrollbars();
                }
            }, 300)).on('load', () => {
                if (this.$window.width() >= this.mobileBreakpoint) {
                    // this.addScrollbars();
                }
            });
        }
    }

    // addScrollbars () {
    //     for (let i = 0; i < this.$links.length; i++) {
    //         this.scrollbars.push(new Ps(this.$links[i]));
    //     }
    // }
    //
    // destroyScrollbars () {
    //     this.scrollbars.forEach((ps) => ps.destroy());
    // }
    //
    // updateScrollbars () {
    //     this.scrollbars.forEach((ps) => ps.update());
    // }

    toggleMenu (e) {
        const $elem = $(e.currentTarget);

        $elem.toggleClass('is-open');
        $elem.closest(this.$wrapper).find(this.$links).slideToggle(300);

        if ($elem.hasClass('is-open')) {
            $elem.attr('aria-expanded', 'true');
        } else {
            $elem.attr('aria-expanded', 'false');
        }
    }

    resetEverything () {
        this.$button.removeClass('is-open');
        this.$links.removeAttr('style');
    }
}

export default SubMenu;
